var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 241.96 193.56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edf3f9;}.cls-2,.cls-7{fill:#0d30ba;}.cls-3{fill:#fff;}.cls-4{fill:#15341a;}.cls-5{fill:#15b01a;}.cls-10,.cls-5{opacity:0.2;}.cls-10,.cls-11,.cls-5,.cls-7,.cls-8{isolation:isolate;}.cls-10,.cls-11,.cls-6{fill:#49b1ff;}.cls-7,.cls-8{opacity:0.1;}.cls-9{fill:#15531a;}.cls-11{opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 121.6,
    cy: 187.49,
    rx: 120.36,
    ry: 6.07
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.08,8.89V178.64a8.88,8.88,0,0,1-8.89,8.88H118.48a8.89,8.89,0,0,1-8.89-8.88V8.89A8.89,8.89,0,0,1,118.48,0h86.74A8.88,8.88,0,0,1,214.08,8.89Z",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.78,8.66v166a8.4,8.4,0,0,1-8.13,8.63H122.06a8.39,8.39,0,0,1-8.13-8.62V8.66A8.38,8.38,0,0,1,122.06,0h79.59A8.39,8.39,0,0,1,209.78,8.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.08,14.68V8.89A8.89,8.89,0,0,0,205.19,0H118.48a8.89,8.89,0,0,0-8.89,8.89v5.79Zm0,158.16v5.8a8.89,8.89,0,0,1-8.89,8.88H118.48a8.89,8.89,0,0,1-8.89-8.88v-5.8Z",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.5,52.35V65.4h-2.17V52.35H151V30.61h10.87V52.35Zm56.56,8.7h4.34v39.13H207.51V61.05h4.35V55.62H214v5.43Zm11.95,0h-4.34V41.48H226V36.09h2.18v5.43h4.34V61.09h-4.34v5.43H226ZM171.67,44.74H176V65.4h-4.36v5.43H169.5V65.4h-4.35V44.74h4.35V39.32h2.17v5.42Zm26.1,34.79V74.06h2.17V79.5h4.35V94.72H193.37V79.53Zm-14.14,0h-4.35V60h10.88V79.53h-4.35v8.7h-2.18Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.65,98.08V63.16h6.66V98.08Zm-14.17-5.43v-11h6.66v11ZM181.37,77.42V62.07H188V77.42ZM167.23,63.29V46.85h6.66V63.29ZM223.79,59V43.6h6.66V59Zm-70.7-8.71V32.71h6.67V50.24Z",
    style: {
      fill: "rgb(17, 192, 128)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.59,100.64c6.2,15.78,33.81,2.24,33.81,2.24s1.25,8.49-7.05,11.25a14.52,14.52,0,0,0-.57,9.07s13-2.84,14.54-13.55S95.4,94,95.4,94s-17.77.43-21.15-11.78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M53.59,100.64c6.2,15.78,33.81,2.24,33.81,2.24s1.25,8.49-7.05,11.25a14.52,14.52,0,0,0-.57,9.07s13-2.84,14.54-13.55S95.4,94,95.4,94s-17.77.43-21.15-11.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.24,88.61C35.35,95.71,33.8,101.37,32,110.21s-10,13.9-11.31,14.08c0,0,.29,11.69-7.17,17.84a45.72,45.72,0,0,0,4.93,11.31s8.54-15.23,8.61-22.11c0,0,26.66-4.94,31.46-19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.24,88.61C35.35,95.71,33.8,101.37,32,110.21s-10,13.9-11.31,14.08c0,0,.29,11.69-7.17,17.84a45.72,45.72,0,0,0,4.93,11.31s8.54-15.23,8.61-22.11c0,0,26.66-4.94,31.46-19"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.93,83.87C24.66,75,7.75,80.05,7.75,80.05S1.15,81.67.48,88.13c-.21,2,.25,3.6-.48,5.2,0,0,6.79-2,9.35-5.73,1.38-2,.63-4.46.1-6.35,0,0,12.66-3.07,13.35,2S4.22,88,6.79,98.94c2.33,9.91,20.59,2.42,20.59,2.42l.74-5.85s-16.62,7.95-16.88.5c-.18-5.59,13.89-5.49,13.69-12.14Z",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.06,155.67s8.55-15.18,8.61-22.06c0,0,24.72-1.1,29.5-15.17,0,0,6.6-5.1,23.09-6.38S91,105.87,91,105.87s6.46-4.4,8-8.89a14,14,0,0,1,6.56,9s7.53,3,11.45.6l2.75-22s15.83-.12,17.68-8.81c0,0-8.94,6.72-24.24-.8S88.74,56,76.67,56.75,49.79,83.79,35.9,90.9s-15.44,12.77-17.25,21.61S8.59,126.4,7.34,126.59c0,0,.28,11.69-7.18,17.84a45.86,45.86,0,0,0,4.9,11.24Z",
    style: {
      paintOrder: "fill",
      fill: "rgb(14, 72, 198)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M43.21,118.4s2-10.73-6.92-15.66c0,0,10.05.8,14.86,12.05a39.49,39.49,0,0,0-5.08,2C45.16,117.17,43.21,118.4,43.21,118.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.23,103.59C63.44,119.38,91,105.84,91,105.84s1.25,8.49-7.05,11.25a14.61,14.61,0,0,0-.56,9s13-2.82,14.54-13.53,1.08-15.69,1.08-15.69-17.77.42-21.15-11.78",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M119.08,90.3l-8.77-10.25s20.38,4.6,27.18-4.37c0,0-1.19,8.08-17.68,8.81l-.73,5.81Zm-2,16.2s-3,2.38-11.45-.59c0,0-1.62-6.65-6.56-9l-.22-4.85a16.42,16.42,0,0,1,8.89,11.75M63.41,83.58s-3.52,33.78,24.24,23.72a66.4,66.4,0,0,1-17.26,4.31C63.22,112.28,59.87,100.43,63.41,83.58Zm34,12.7s-15.72,3.33-19.5-11.14ZM9.48,81.22,7.75,80.05s-4.58,1.16-6.41,5.06a16.92,16.92,0,0,0-.9,4.56c0,2.14,0,2.63-.42,3.64,0,0,7.35-2,9.7-6.35C10.78,85,9.48,81.22,9.48,81.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M130.9,138H76.58A4.61,4.61,0,0,0,72,142.5V171a4.58,4.58,0,0,0,4.62,4.44L131,175l5-4-.52-28.54a4.62,4.62,0,0,0-1.34-3.2A4.72,4.72,0,0,0,130.9,138Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.74,144.88a11.81,11.81,0,1,1-8.39,3.46A11.85,11.85,0,0,1,103.74,144.88Z",
    style: {
      fill: "rgb(4, 38, 19)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80.28,
    cy: 156.85,
    r: 3.3,
    style: {
      fill: "rgb(4, 38, 19)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.84,150.37a.39.39,0,0,1,.25.39v1a.28.28,0,0,1-.23.26h-2.44a.31.31,0,0,0,0,.1,3.42,3.42,0,0,1,.55,1.23c0,.1.07.13.17.13h1.5c.29,0,.4.1.4.39v.88c0,.29-.11.39-.39.39h-1.47c-.1,0-.13,0-.16.13a3.65,3.65,0,0,1-1,2,4.22,4.22,0,0,1-1.49,1,5.34,5.34,0,0,1-1.36.35h-.16l0,.07,1.31,1.46,1.34,1.57,1.8,2.17a.35.35,0,0,1,.13.33.34.34,0,0,1-.22.27h-1.86a.65.65,0,0,1-.5-.22c-.35-.41-.7-.81-1-1.25l-.93-1.07-1.56-1.72c-.44-.51-.89-1-1.35-1.49a.42.42,0,0,1-.12-.3v-1.16a.37.37,0,0,1,.1-.3.33.33,0,0,1,.29-.09h1a5,5,0,0,0,1.8-.28,2.18,2.18,0,0,0,1.09-.8,1.73,1.73,0,0,0,.28-.6H99.35a.31.31,0,0,1-.24-.29v-1.09a.28.28,0,0,1,.28-.27h4.16v-.08a1.78,1.78,0,0,0-1-.81,4.16,4.16,0,0,0-1.52-.26H99.53c-.3,0-.42-.14-.4-.46a10.09,10.09,0,0,0,0-1.1.38.38,0,0,1,.24-.42Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140.19,117.14h43.33v6.75H140.19Zm-6.6,13.42h56.53v6.74H133.59Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M45.43,36.6,48,36A7.89,7.89,0,0,0,54,29.76L54.52,27,55,29.46a7.83,7.83,0,0,0,6.23,6.1l2.81.54-2.67.62a7.9,7.9,0,0,0-6,6.36L55,45.66l-.76-2.94a7.86,7.86,0,0,0-6.53-5.83Zm33-20.14,1.41-.31a4.36,4.36,0,0,0,3.36-3.48l.28-1.52.29,1.36a4.35,4.35,0,0,0,3.46,3.39l1.55.3-1.47.34A4.35,4.35,0,0,0,84,20.07L83.7,21.5l-.42-1.62a4.35,4.35,0,0,0-3.62-3.23l-1.26-.19ZM227.08,121.34l1.76-.38a5.43,5.43,0,0,0,4.18-4.34l.34-1.88.36,1.68a5.44,5.44,0,0,0,4.31,4.23L240,121l-1.85.43a5.46,5.46,0,0,0-4.14,4.4l-.3,1.79-.52-2a5.46,5.46,0,0,0-4.52-4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPms);
export default __webpack_public_path__ + "static/media/PMS.391d3710e1773fb183452014d5ea7c88.svg";
export { ForwardRef as ReactComponent };